module.exports = __webpack_public_path__ + "img/51.2e9acb2a.png";